const map = {
	"./ar/slot.jpg": 26542,
	"./de/slot.jpg": 32918,
	"./en/slot.jpg": 40286,
	"./fr/slot.jpg": 17161,
	"./it/slot.jpg": 6484,
	"./kh/slot.jpg": 48666,
	"./krt/slot.jpg": 92480,
	"./nl/slot.jpg": 71415,
	"./tr/slot.jpg": 20955
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97454;